import React from 'react';
import styled from 'styled-components/macro';
import { colors, defaultRadius, distances, grid } from '../../../styles/constants';
import { H2, P } from '../../../components/Typography';
import { ButtonExternalLink } from '../../../components/Buttons';
import { useTranslation } from 'react-i18next';


const Container = styled.div`
    max-width: ${grid.spans.span7};
    margin: 0 auto 100px;
    padding: ${distances.normal};
    position: relative;
    min-height: calc(${distances.ginormous} + ${distances.large});
    border: 1px solid ${colors.borderLight};
    border-radius: ${defaultRadius};
`;

const NoCustomers = () => {
    const { t } = useTranslation();
    const link = 'https://docs.dintero.com/docs/customer-service/';
    return (
        <Container>
            <H2>{t('customers.customers.no_customers.title')}</H2>
            <br/>
            <br/>
            <P>{t('customers.customers.no_customers.body')}</P>
            <br/>
            <br/>
            <ButtonExternalLink href={link}>{t('customers.customers.no_customers.call_to_action')}</ButtonExternalLink>
        </Container>
    );
};

export default NoCustomers;
